<template>
<!--     <ProgressHUD
        ref="progress"
        :display="true"
    />
 -->
  <layout-main>

    <div id="page-content-wrapper">
      <div  class="container">

        <div class="row">
          <div class="col-lg-12">
              <h4 class="page-header">Settings</h4>
          </div>
        </div>

        <div class="header">
          <h5 class="title" id="">FIAT Payment</h5>
        </div>
        <div class="modal-body">
          <h5 class="title" id="">Add FIAT Payment</h5>
          <form class="popup-payment-form" >

            <div class="form-group">



              <div class="panel-group" id="accordion">
                 <!--  <div class="panel panel-default">
                    <div class="panel-heading line">                      
                        <a data-toggle="collapse" data-parent="#accordion" href="#collapse1"><span>Bitcoin Wallet</span></a>                      
                    </div>
                    <div id="collapse1" class="panel-collapse collapse in">
                      <div class="wallet panel-body row profile-box">
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                          <input type="text" placeholder="" name="walletBTC" v-model="walletBTC" >
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="panel panel-default">
                    <div class="panel-heading">                      
                        <a data-toggle="collapse" data-parent="#accordion" href="#collapse2"><span>Ether Wallet</span></a>
                    </div>
                    <div id="collapse2" class="panel-collapse collapse">
                      <div class="wallet panel-body row profile-box">
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                          <input type="text" placeholder="" v-model="wallet">                        
                          <a href="https://myetherwallet.github.io/knowledge-base/getting-started/creating-a-new-wallet-on-myetherwallet.html" class="generate" target="_blank">Generate one</a>
                        </div>
                      </div>
                    </div>
                  </div> -->
                  <div class="panel panel-default">
                    <div class="panel-heading">
                      <a data-toggle="collapse" data-parent="#accordion" href="#collapse3"><span>Credit Card</span></a>
                    </div>
                    <div id="collapse3" class="panel-collapse collapse">
                      <div class="row profile-box">
                        <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3">
                            <span class="inp-label">Number</span>
                        </div>
                        <div class="col-xs-12 col-sm-9 col-md-9 col-lg-9">
                            <input type="text" placeholder="" name="number" v-model="number" v-validate="'credit_card'" :class="{'error-input': errors.has('number') }">
                            <span class="error" v-if="errors.has('number')">{{errors.first('number')}}</span><br v-if="errors.has('number')">
                        </div>
                        <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3">
                            <span class="inp-label">Exp. date</span>
                        </div>
                        <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2">
                            <span style="white-space: nowrap;"><input type="text" placeholder="mm" class="mm" v-model="expDate" name="expDate" v-validate="'max:2|numeric|between:1,12'" :class="{'error-input': errors.has('expDate') }"> <span class="_mm">/</span></span>
                            <span class="error" v-if="errors.has('expDate')">{{errors.first('expDate')}}</span>
                        </div>
                        <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2">
                            <input type="text" placeholder="yyyy" v-model="expDateYear" name="expDateYear" v-validate="'max:4|min:4|numeric|between:1900,2050'" :class="{'error-input': errors.has('expDateYear') }">
                            <span class="error" v-if="errors.has('expDateYear')">{{errors.first('expDateYear')}}</span>
                        </div>
                         <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2">
                            <span class="inp-label cvv">CVV</span>
                        </div>
                        <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3">
                            <input type="text" placeholder="" v-model="cvv" v-validate="'numeric|max:3|min:3'" name="cvv" :class="{'error-input': errors.has('cvv')}">
                            <span class="error" v-if="errors.has('cvv')">{{errors.first('cvv')}}</span>
                        </div>                      
                      </div>
                    </div>
                  </div>
                  <div class="panel panel-default">
                    <div class="panel-heading">                      
                        <a data-toggle="collapse" data-parent="#accordion" href="#collapse4"><span>Bank Account</span></a>
                    </div>
                    <div id="collapse4" class="panel-collapse collapse">
                        <div class="row profile-box">
                          <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3">
                              <span class="inp-label">IBAN</span>
                          </div>
                          <div class="col-xs-12 col-sm-9 col-md-9 col-lg-9">
                              <input type="text" placeholder="" v-model="iban" name="iban" :class="{'error-input': errors.has('iban')}" v-validate="'max:34'">
                              <span class="error" v-if="errors.has('iban')">{{errors.first('iban')}}</span>
                          </div>
                          <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3">
                              <span class="inp-label">Swift code</span>
                          </div>
                          <div class="col-xs-12 col-sm-9 col-md-9 col-lg-9">
                              <input type="text" placeholder="" v-model="sCode" name="sCode" v-validate="'max:11'" :class="{'error-input': errors.has('sCode')}">
                              <span class="error" v-if="errors.has('sCode')">{{errors.first('sCode')}}</span>
                          </div>                      
                      </div>
                    </div>
                  </div>
                  <div class="panel panel-default">
                    <div class="panel-heading">                      
                        <a data-toggle="collapse" data-parent="#accordion" href="#collapse5"><span>PayPal</span></a>
                    </div>
                    <div id="collapse5" class="panel-collapse collapse">
                      <div class="row profile-box">
                        <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3">
                            <span class="inp-label">Email</span>
                        </div>
                        <div class="col-xs-12 col-sm-9 col-md-9 col-lg-9">
                            <input type="text" placeholder="email" v-model="pp" name="email" v-validate="'email'" :class="{'error-input': errors.has('email')}">
                            <span class="error" v-if="errors.has('email')">{{errors.first('email')}}</span>
                        </div>                        
                      </div>
                      </div>
                  </div>
                </div>





              <!-- <div class="line"  @click="choosedMethod('btc')"><div class="" :class="{'active': paymentMethod=='btc'}" @click="choosedMethod('btc')"></div><span>Bitcoin Wallet</span></div>
              <div v-if="paymentMethod=='btc'" class="wallet">
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <input type="text" placeholder="" name="walletBTC" v-model="wallet" :class="{'error-input': errors.has('walletBTC')}" v-validate="'required'">
                        <span class="error" v-if="errors.has('walletBTC')">{{errors.first('walletBTC')}}</span><br v-if="errors.has('walletBTC')">
                        <button type="button" class="btn btn-primary" @click="save('btc')">Save</button>
                    </div>
              </div>
              <div class="line"><div class="chbx" :class="{'active': paymentMethod=='eth'}" @click="choosedMethod('eth')"></div><span @click="choosedMethod('eth')">Ether Wallet</span></div>
              <div v-if="paymentMethod=='eth'" name="wallet" class="wallet">
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <input type="text" placeholder="" v-model="wallet" :class="{'error-input': errors.has('wallet')}" v-validate="'required'">
                        <span class="error" v-if="errors.has('wallet')">{{errors.first('wallet')}}</span><br v-if="errors.has('wallet')">
                        <a href="https://myetherwallet.github.io/knowledge-base/getting-started/creating-a-new-wallet-on-myetherwallet.html" class="generate" target="_blank">Generate one</a>
                        <button type="button" class="btn btn-primary w-eth" @click="save('eth')">Save</button>
                    </div>
              </div>
              <div class="line"><div class="chbx" :class="{'active': paymentMethod=='cc'}" @click="choosedMethod('cc')"></div><span @click="choosedMethod('cc')">Credit Card</span></div>
              <div v-if="paymentMethod=='cc'" class="row profile-box">
                    <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3">
                        <span class="inp-label">Number</span>
                    </div>
                    <div class="col-xs-12 col-sm-9 col-md-9 col-lg-9">
                        <input type="text" placeholder="" name="number" v-model="number" v-validate="'required|credit_card'" :class="{'error-input': errors.has('number') }">
                        <span class="error" v-if="errors.has('number')">{{errors.first('number')}}</span><br v-if="errors.has('number')">
                    </div>
                    <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3">
                        <span class="inp-label">Exp. date</span>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2">
                        <span style="white-space: nowrap;"><input type="text" placeholder="mm" class="mm" v-model="expDate" name="expDate" v-validate="'required|max:2|numeric|between:1,12'" :class="{'error-input': errors.has('expDate') }"> <span class="_mm">/</span></span>
                        <span class="error" v-if="errors.has('expDate')">{{errors.first('expDate')}}</span>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2">
                        <input type="text" placeholder="yyyy" v-model="expDateYear" name="expDateYear" v-validate="'required|max:4|min:4|numeric|between:1900,2050'" :class="{'error-input': errors.has('expDateYear') }">
                        <span class="error" v-if="errors.has('expDateYear')">{{errors.first('expDateYear')}}</span>
                    </div>
                     <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2">
                        <span class="inp-label">CVV</span>
                    </div>
                    <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3">
                        <input type="text" placeholder="" v-model="cvv" v-validate="'required|numeric|max:3|min:3'" name="cvv" :class="{'error-input': errors.has('cvv')}">
                        <span class="error" v-if="errors.has('cvv')">{{errors.first('cvv')}}</span>
                    </div>
                    <button type="button" class="btn btn-primary" @click="save('cc')">Save</button>
              </div>
              <div class="line"><div class="chbx" :class="{'active': paymentMethod=='bacc'}" @click="choosedMethod('bacc')"></div><span @click="choosedMethod('bacc')">Bank Account</span></div>
              <div v-if="paymentMethod=='bacc'" class="row profile-box">
                    <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3">
                        <span class="inp-label">IBAN</span>
                    </div>
                    <div class="col-xs-12 col-sm-9 col-md-9 col-lg-9">
                        <input type="text" placeholder="" v-model="iban" name="iban" :class="{'error-input': errors.has('iban')}" v-validate="'required|max:34'">
                        <span class="error" v-if="errors.has('iban')">{{errors.first('iban')}}</span>
                    </div>
                    <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3">
                        <span class="inp-label">Swift code</span>
                    </div>
                    <div class="col-xs-12 col-sm-9 col-md-9 col-lg-9">
                        <input type="text" placeholder="" v-model="sCode" name="sCode" v-validate="'required|max:11'" :class="{'error-input': errors.has('sCode')}">
                        <span class="error" v-if="errors.has('sCode')">{{errors.first('sCode')}}</span>
                    </div>
                    <button type="button" class="btn btn-primary" @click="save('bacc')">Save</button>
              </div>
              <div class="line"><div class="chbx" :class="{'active': paymentMethod=='pp'}" @click="choosedMethod('pp')"></div><span @click="choosedMethod('pp')">PayPal</span></div>
              <div v-if="paymentMethod=='pp'" class="row profile-box">
                    <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3">
                        <span class="inp-label">Email</span>
                    </div>
                    <div class="col-xs-12 col-sm-9 col-md-9 col-lg-9">
                        <input type="text" placeholder="email" v-model="wallet" name="email" v-validate="'required|email'" :class="{'error-input': errors.has('email')}">
                        <span class="error" v-if="errors.has('email')">{{errors.first('email')}}</span>
                    </div>
                    <button type="button" class="btn btn-primary" @click="save('pp')">Save</button>
              </div> -->
            </div>

            <div class="input-field-indented"></div>

          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" @click="save('pp')">Save</button>
          <router-link to="/payment/edit" class="btn btn-secondary" >Back</router-link>
          <!-- <button type="button" class="btn btn-primary" @click="sendReport()">Save changes</button> -->
        </div>
    </div>
  </div>  
</layout-main>

</template>

<style type="text/css">
  #exampleModalCenter.modal .modal-footer .btn-primary {
      padding: 8px 14px;
      background: #00b248;
      /*box-shadow: 0 3px 6px #d8d8d8;*/
      float: right;
      margin-left: 15px;
      transition: 0.3s;
      border: none;
      color: #fff;
  }
  #exampleModalCenter.modal .modal-title {
      width: auto;
      float: left;
  }
  #exampleModalCenter.modal .close {
      color: #00b248;
      opacity: 1;
      font-size: 50px;
      float: right;
      line-height: 20px;
  }
  #exampleModalCenter.modal .modal-body form .form-group {
      width: 48%;
      display: inline-block;
  }
  #exampleModalCenter.modal .modal-body form .form-group:first-child {width: 100%;}
  #exampleModalCenter.modal .input-field {
      padding-top: 13px;
      width: 48%;
      display: inline-block;
      margin-left: 3%;
  }
  .popup-payment-form .line {
    width: 75%;
    margin: 15px;
    margin-left: 30%;
  }
  .popup-payment-form .line span {
    padding: 25px;
  }
  .popup-payment-form .active {
    background-color: #001b9d;
  }
  #exampleModalCenter.modal input {
      border-radius: 0;
      border: transparent;
      box-shadow: none;
      margin-bottom: 10px;
      padding: 0;
      line-height: normal;
      height: auto;
      /* font-size: 20px; */
      /* font-style: italic; */
      width: 100%;
      border-bottom: 2px solid #00e676;
      color: #333;
      margin-top: 10px;
  }
  #exampleModalCenter.modal .form-group .btn-primary {
      padding: 8px 14px;
      background: #00b248;
      margin: 15px 0px;
      -webkit-transition: 0.3s;
      transition: 0.3s;
      border: none;
      color: #fff;
      border-radius: unset;
  }
  #exampleModalCenter.modal .col-xs-12, #exampleModalCenter.modal .row.profile-box {
    text-align: center;
  }
  #exampleModalCenter.modal .line span {
    cursor: pointer;
  }
  #exampleModalCenter.modal .profile-box .inp-label {
      font-size: 15px;
      margin-top: 20px;
  }
  .mm {
    margin-right: 10px;
  }
  ._mm {
      color: #00e676;
      font-weight: bold;
  }
  #exampleModalCenter.modal .form-group .w-eth {
        margin-right: 15%;
  }
  #exampleModalCenter.modal .profile-box .inp-label {
    padding-right: 20px;
  }
  #exampleModalCenter.modal input.error-input {
    border-bottom: 2px solid #e2574c;
    margin-bottom: auto;
  }
  .inp-label.cvv {
    width: 100%;
    text-align: right;
  }
</style>
<script>
import LayoutMain from './../../../layouts/LayoutMain.vue';
import { Toast, Api, Helper } from './../../../services'

export default {
  name: "AddPayment",
  components: {LayoutMain},
  data() {
    return ({      
      paymentMethod: '',
      wallet: '',
      number: '',
      expDate: '',
      expDateYear: '',
      cvv: '',
      iban: '',
      sCode: '',
      validationMessage: '',
      walletBTC: '',
      pp: '',
      year: (new Date()).getFullYear(),
    })
  },
  methods: {
    openDialog() {
      this.paymentMethod = '';
      this.wallet = ''
      this.number = ''
      this.expDate = ''
      this.expDateYear = ''
      this.cvv = ''
      this.iban = ''
      this.sCode = ''
      $('#exampleModalCenter').modal('show');
    },
    choosedMethod(method) {
      this.paymentMethod = method;
    },
    async save(method) {
      try {
         console.log("test**************")
        
          const isValid = await this.$validator.validateAll()
          if (!isValid) {
            Toast.error({
              toast: this.$toast,
              message: 'The entered data is not valid',
            })

            return
          }
          // if (this.$parent.$refs.progress) {
          //   this.$parent.$refs.progress.show()
          // } else {
          //   this.$parent.$parent.$refs.progress.show()
          // }

          var data = [], i=0

          if (this.number != '') {
            data[i] = {}
            data[i]['name'] = 'cc'
            var data1 = {}
            data1["number"] = this.number
            data1["expDate"] = this.expDate
            data1["cvv"] = this.cvv
            data[i]['value'] = JSON.stringify(data1)
            i++;
          } 
          if (this.iban != '') {
            data[i] = {}
            data[i]['name'] = 'bacc'
            var data1 = {}
            data1["iban"] = this.iban
            data1["sCode"] = this.sCode
            data[i]['value'] = data1 // JSON.stringify(data1)
            i++;
          } 
          if((this.pp != '')) {
            data[i] = {}
            data[i]['name'] = 'pp'            
            data[i]['value'] = this.pp
            i++;
          }
          if((this.wallet != '')) {
            data[i] = {}
            data[i]['name'] = 'eth'
            data[i]['value'] = this.wallet
            i++;
          }
          if((this.walletBTC != '')) {
            data[i] = {}
            data[i]['name'] = 'btc'
            data[i]['value'] = this.walletBTC          
          }

          console.log("data**************************************")
          console.log(data)

          var newMethods = JSON.stringify( data );
          var response = await Api.addPaymentMethod(newMethods)
          console.log("response>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>")
          console.log(response)

          Toast.success({
            toast: this.$toast,
            message: "Payment Method successfully added",
          })
      } catch (error) {
        console.error(error)

        Toast.error({
          toast: this.$toast,
          message: error.message,
        })
      } finally {
        if (this.$parent.$refs.progress) {
         // this.$parent.$refs.progress.hide()
        } else {
         // this.$parent.$parent.$refs.progress.hide()
        }
      }
    },
    cancelReport() {
      $('#exampleModalCenter').modal('hide');
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Account/EditPayment/addPayment.vue